import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const NotFound = () => {
  return (
    <section className="d-flex align-items-center min-vh-100 py-5">
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="text-center">
            <div className=" mb-3">
              <div editable="rich">
                <h1 className="fw-bold h4">PAGE NOT FOUND!</h1>
              </div>
            </div>
            <div className=" mb-3">
              <div editable="rich">
                <h1 className="display-1 fw-bold text-muted">Error 404</h1>
              </div>
            </div>
            <div className=" mb-5">
              <div editable="rich">
                <p className="rfs-11 fw-light">
                  {" "}
                  The page you are looking for was moved, removed or might never
                  existed.
                </p>
              </div>
            </div>
            <div className="">
              <a className="btn btn-lg btn-secondary" href="/" role="button">
                Back to homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
